<template>
    <div class="mall">
        <mall-header>文创商城</mall-header>
        <div class="wrap">
            <header class="top"></header>
            <div class="codeBox">
                <div class="icon">
                    <img src="../../assets/images/wcsc.png" alt="">
                </div>
                <h2 class="title">进入商城入口</h2>
                <p>
                    长按二维码保存到手机<br>
                    用微信打开
                </p>
            </div>
        </div>
        <section class="intro">
            文创商城是协会基于大货郎电子商务平台设立的一个网上企业联盟商城。协会致力于为全体会员打造一个产品来源安全可靠、产品更有竞争力的网上资源共享商城。加入商城还可以享受更多的会员服务，期待您的加入。
        </section>
    </div>
</template>

<script>
import mallHeader from '../../components/Header';
export default {
    name: 'mall',
    components: {
        mallHeader
    },
    data() {
        return {
            
        }
    },
}
</script>

<style scoped>
.mall{
    background: #F2F3F7;
    min-height: 100vh;
} 
.wrap{
    position: relative;
    height: 7.5rem;
}
.top{
    height: 3.88rem;
    background: #D60000;
    border-radius: 0 0 50% 50%;
    position: relative;
}
.codeBox{
    text-align: center;
    overflow: hidden;
    position: absolute;
    top: 2.4rem;
    left: 0;
    right: 0;
    margin: auto;
}
.codeBox .icon{
    width: 2.76rem;
    height: 2.76rem;
    margin: 0 auto;
}
.codeBox .icon img{
    width: 100%;
}
.codeBox .title{
    font-size: .28rem;
    font-weight: bold;
    margin-top: .4rem;
}
.codeBox p{
    line-height: 1.5;
    margin-top: .2rem;
}
.intro{
    padding: 0 .7rem;
    line-height: 1.5;
    font-size: .28rem;
    text-indent: 2em;
}
</style>